import MainLayout from "@/components/layout/applicant/MainLayout.vue";
import axios from "axios";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
    name: "JobRequestDetail",
    components: {
        MainLayout,
    },

    data() {
        return {
            jobRequest: {
                job_request_title: '',
                job_request_details: '',
                name: ''
            }
        };
    },

    computed: {
        ...mapGetters({ 
            isApplicantLoggedIn: "isApplicantLoggedIn", 
            applicantId: "applicantId", 
            applicantToken: "applicantToken",
            isCompanyLoggedIn: "isCompanyLoggedIn"
        }),
        isOwner() {
            return !!(
                this.isApplicantLoggedIn &&
                this.applicantId &&
                this.jobRequest &&
                this.jobRequest.applicant_id &&
                Number(this.jobRequest.applicant_id) === Number(this.applicantId)
            );
        }
    },
    
    methods: {
        getJobRequestDetail() {
            axios.get("applicant/job_request/detail/" + this.$route.params.id)
                .then(response => {
                    if (!response.data || !response.data.id) {
                        this.$router.push({ name: "notFound" });
                        return;
                    }
                    this.jobRequest = response.data;
                })
                .catch(error => {
                    console.log("Job Request Detail API error", error.response ? error.response.data : error);
                    this.$router.push({ name: "notFound" });
                });
        },

        confirmDelete(id) {
            if (window.confirm("ဤအလုပ်ရှာပိုစ့်ကို ဖျက်လိုပါသလား?")) {
                this.deleteJobRequest(id);
            } else {
                console.log("no");
            }
        },

        deleteJobRequest(id) {
            axios.delete("/applicant/job_request/delete/" + id)
                .then(() => {
                    if (this.$notification) {
                        this.$notification.success("အလုပ်ရှာပို့စ်ဖျက်ခြင်း အောင်မြင်သည်။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                    this.$router.push({
                        name: 'jobRequest',
                    });
                })
                .catch(error => {
                    if (this.$notification) {
                        this.$notification.error("လုပ်ဆောင်ချက်မအောင်မြင်ပါ။", {
                            timer: 3,
                            position: "bottomCenter"
                        });
                    }
                    console.log(error);
                })
        },

        setMoment(date) {
            if (!date) return '';
            return moment(date).fromNow();
        },

        getJobType(type) {
            const types = {
                1: 'Full-time',
                2: 'Part-time',
                3: 'Internship',
                4: 'Freelance',
                5: 'Remote Job'
            };
            return types[type] || '';
        }
    },
    
    mounted() {
        this.getJobRequestDetail();
    }
};